import * as React from 'react';

import Loader from 'bundles/degree-home/components/Loader';
import SummaryCourseItem from 'bundles/degree-home/components/SummaryCourseItem';

import _t from 'i18n!nls/degree-home';

import { SummaryCard } from './SummaryCard';
import type { GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_passed as PassedCourse } from './v2/UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';

type Props = {
  loading: boolean;
  passedCourses?: Array<PassedCourse>;
};

export const EndedCourses = ({ loading, passedCourses }: Props) => (
  <SummaryCard title={_t('Ended')}>
    {loading && <Loader />}
    {!loading &&
      passedCourses?.map((passedCourse: PassedCourse) => (
        <SummaryCourseItem
          key={passedCourse.id}
          courseId={passedCourse.id}
          courseName={passedCourse.name}
          courseSlug={passedCourse.slug}
          statusText={_t('Ended')}
          isCourseEnrollable={false}
        />
      ))}
  </SummaryCard>
);

export default EndedCourses;
